import React from 'react';
import { NavLink } from 'react-router-dom';
import { MailIcon } from 'lucide-react';
import { sections } from '../data/sections';
interface SectionRailProps {
  onNavigate?: () => void;
}
export function SectionRail({
  onNavigate
}: SectionRailProps) {
  return <div className="flex h-full flex-col bg-navy pattern-grid" data-id="element-65" data-mp="2anh9wb94qtj6">
      <div className="border-b border-white/10 px-7 py-7" data-id="element-66" data-mp="2fiwjus40o5ab">
        <NavLink to="/" onClick={onNavigate} className="flex items-center gap-4" data-id="element-67" data-mp="20vjuesb39fen">
          <span className="flex h-11 w-11 items-center justify-center border border-gold/60 font-serif text-base text-gold" data-id="element-68" data-mp="25n1yhp8erw3u">
            JM
          </span>
          <span data-id="element-69" data-mp="1rsslaz5oqvq6">
            <span className="block font-serif text-lg leading-tight text-white" data-id="element-70" data-mp="1wtggzy4v00qq">
              Janice Munday
            </span>
            <span className="mt-0.5 block text-[10px] font-semibold uppercase tracking-overline text-gold" data-id="element-71" data-mp="1hxh3g7yzd8e7">
              Chair · NED
            </span>
          </span>
        </NavLink>
      </div>

      <nav aria-label="Section directory" className="flex-1 overflow-y-auto px-4 py-5" data-id="element-72" data-mp="23lp0tyf2wddp">
        <p className="px-3 pb-3 text-[10px] font-semibold uppercase tracking-overline text-slate-500" data-id="element-73" data-mp="1ymvm62o22gby">
          Section Directory — 10 Sections
        </p>
        <ul data-id="element-74" data-mp="28m4bujbw18si">
          {sections.map(section => <li key={section.path} data-id="element-75" data-mp="28mmdxwl8eh8c">
              <NavLink to={section.path} end={section.path === '/'} onClick={onNavigate} className={({
            isActive
          }) => ['group flex gap-3 border-l-2 px-3 py-3 transition-colors duration-150 ease-out', isActive ? 'border-gold bg-white/5' : 'border-transparent hover:border-white/25 hover:bg-white/[0.03]'].join(' ')} data-id="element-76" data-mp="1kw0jj845gvgt">
                {({
              isActive
            }) => <>
                    <span className={['mt-0.5 font-serif text-[11px]', isActive ? 'text-gold' : 'text-slate-500'].join(' ')} data-id="element-77" data-mp="2wbpglfxpkx39">
                      {section.index}
                    </span>
                    <span className="min-w-0" data-id="element-78" data-mp="3b02c6bsvwdx8">
                      <span className={['block text-[13px] font-semibold leading-snug', isActive ? 'text-gold' : 'text-slate-200'].join(' ')} data-id="element-79" data-mp="3azspoy71sowa">
                        {section.navLabel}
                      </span>
                      <span className="mt-1 block text-[11px] leading-snug text-slate-500" data-id="element-80" data-mp="2s9udc5w7w9mu">
                        {section.summary}
                      </span>
                    </span>
                  </>}
              </NavLink>
            </li>)}
        </ul>
      </nav>

      <div className="border-t border-white/10 px-7 py-6" data-id="element-81" data-mp="1s1ea3qz7c9iv">
        <a href="mailto:janice.m.munday@gmail.com" className="flex items-center gap-2 text-[12px] text-slate-400 transition-colors duration-150 ease-out hover:text-gold" data-id="element-82" data-mp="1s0upu3m2x91o">
          <MailIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-83" data-mp="1ia0553ohehic" />
          janice.m.munday@gmail.com
        </a>
      </div>
    </div>;
}